import LocalizedStrings from 'react-localization';

export const strings = new LocalizedStrings({
    en: {
        allLines: "All lines",
        allStops: "All stops",
        areYouSure: "Are you sure you want to continue?",
        arrowColor: "Arrow color",
        back: "Back",
        cancel: "Cancel",
        cantDeleteSelectedImage: "Can't delete a selected image",
        change: "Save Changes",
        circularDependenciesDetected: "Circular dependencies detected in the following routes:",
        code: "Code",
        delete: "Delete",
        deletePictogram: "Delete pictogram",
        deletePictogramConfirmation: "Are you sure you want to delete this pictogram?",
        description: "Description",
        destination: "Destination",
        edit: "Edit",
        error: "Error!",
        errorLoadingDocs: "Some documents could not be loaded.",
        existingBusMaps: "Existing BusMaps",
        extCode: "External Code",
        filterByLine: "Filter by line",
        filterByStopName: "Filter by stop",
        fontsAndColors: "Fonts and colors",
        footer: "Footer",
        generateBusMaps: "Generate BusMaps",
        generatingBusMaps: "Generating BusMaps",
        generationDate: "Generation Date",
        generationSuccessful: "{0} BusMaps succesfully generated",
        go: "Go",
        header: "Header",
        headerFooterImages: "Header and Footer images",
        image: "Image",
        insertStopName: "Insert stop name",
        labelsSettings: "Labels settings",
        interfaceSettings: "Interface settings",
        invertSelection: "Invert selection",
        lineCode: "Line code",
        lineDescription: "Line description",
        lineNumberFont: "Line number font",
        managingPictograms: "Pictogram management",
        mapPointLabel: "Map Points label",
        mapPointLabelColor: "Background color",
        mapPointLabelFont: "Font",
        mapPointLabelTextColor: "Text color",
        moreThanSix: "You have selected more than 6 routes for the following stops:",
        moreThanSixPost: "The algorithm can't guarantee a good result in these conditions.",
        mustSelectHeaderandFooter: "Must select a header and a footer image.",
        name: "Name",
        nameEn: "Name (EN)",
        nameEnLong: "Name in English",
        namePt: "Name (PT)",
        namePtLong: "Name in Portuguese",
        newPictogram: "New pictogram",
        no: "No",
        noBusMapsGenerated: "No BusMaps were generated. Please check your options.",
        noExistingBusMaps: "There are no existing BusMaps",
        noExistingPictograms: "There are no existing pictograms",
        noExistingStops: "There are no existing stops",
        noFooterImages: "No footer images available",
        noHeaderImages: "No header images available",
        noMapPointsAvailable: "No MapPoints available",
        orientation: "Orientation",
        origin: "Origin",
        pageDimensions: "Page dimensions (in mm)",
        pageFooterHeight: "Footer Height",
        pageHeaderHeight: "Header Height",
        pageHeight: "Height",
        pageMarginBottom: "Bottom",
        pageMarginLeft: "Left",
        pageMarginRight: "Right",
        pageMargins: "Margins",
        pageMarginTop: "Top",
        pageRouteHeaderHeight: "Route Header Height",
        pageSizes: "Page Sizes",
        pageWidth: "Width",
        part: "Part",
        printInterfaces: "Print interfaces",
        printInterfacesLabel: "Print interface labels",
        printProviderLogo: "Print Provider logo",
        printTitle: "Print title",
        removeImage: "Remove image",
        removedImage: "Image successfully deleted",
        required: "Mandatory",
        return: "Return",
        save: "Save changes",
        selectAll: "Select all",
        selectAllRoutesForAllStops: "Select everything",
        selectAllVisibleStops: "Select visible stops",
        selectedStops: "Selected stops",
        selectMapPoints: "Select map points",
        selectRoutes: "Select routes",
        selectStops: "Select stops",
        settings: "Settings",
        settingsUpdated: "Settings updated successfully",
        shortName: "Short Name",
        showSettings: "Show settings",
        showSummary: "Show summary",
        stopLabel: "Stop label",
        stopLabelColor: "Background color",
        stopLabelFont: "Font",
        stopLabelTextColor: "Text color",
        stopsWithNoRoutes: "There were no routes found for the following stops:",
        success: "Success",
        summary: "Summary",
        terminalStopsWithoutMapPoints: "Terminal stops without map points for the following routes:",
        type: "Type",
        upload: "Upload",
        uploadButton: "Upload",
        uploadNew: "Upload new image",
        warning: "Warning",
        yes: "Yes"
    },
    pt: {
        allLines: "Todas as linhas",
        allStops: "Todas as paragens",
        areYouSure: "Deseja continuar?",
        arrowColor: "Cor da seta indicativa",
        back: "Voltar",
        cancel: "Cancelar",
        cantDeleteSelectedImage: "Não é possível apagar uma imagem selecionada",
        change: "Guardar Alterações",
        circularDependenciesDetected: "Foram detectadas dependências circulares nos seguintes percursos:",
        code: "Código",
        delete: "Apagar",
        deletePictogram: "Apagar pictograma",
        deletePictogramConfirmation: "Tem a certeza que deseja apagar este pictograma?",
        description: "Descrição",
        destination: "Destino",
        edit: "Editar",
        error: "Erro!",
        errorLoadingDocs: "Não foi possível carregar alguns documentos.",
        existingBusMaps: "BusMaps existentes",
        extCode: "Código Externo",
        filterByLine: "Filtrar por linha",
        filterByStopName: "Filtrar por paragem",
        fontsAndColors: "Tipos de letra e cores",
        footer: "Rodapé",
        generateBusMaps: "Gerar BusMaps",
        generatingBusMaps: "A gerar BusMaps",
        generationDate: "Data de geração",
        generationSuccessful: "{0} BusMaps gerados com sucesso",
        go: "Ida",
        header: "Cabeçalho",
        headerFooterImages: "Imagens de cabeçalho e rodapé",
        image: "Imagem",
        insertStopName: "Inserir nome da paragem",
        labelsSettings: "Definições de legendas",
        interfaceSettings: "Definições de interfaces",
        invertSelection: "Inverter seleção",
        lineCode: "Número da linha",
        lineDescription: "Descrição da linha",
        lineNumberFont: "Tipo de letra do número da linha",
        managingPictograms: "Gestão de pictogramas",
        mapPointLabel: "Legenda dos Pontos Notáveis",
        mapPointLabelColor: "Cor de fundo",
        mapPointLabelFont: "Tipo de letra",
        mapPointLabelTextColor: "Cor do texto",
        moreThanSix: "Selecionou mais de 6 percursos para as seguintes paragens:",
        moreThanSixPost: "O algoritmo não pode garantir um bom resultado com estas condições.",
        mustSelectHeaderandFooter: "Deve selecionar uma imagem para cabeçalho e outra para rodapé.",
        name: "Nome",
        nameEn: "Nome (EN)",
        nameEnLong: "Nome em Inglês",
        namePt: "Nome (PT)",
        namePtLong: "Nome em Português",
        newPictogram: "Novo pictograma",
        no: "Não",
        noBusMapsGenerated: "Não foram gerados BusMaps. Verifique as suas escolhas.",
        noExistingBusMaps: "Não existem BusMaps gerados.",
        noExistingPictograms: "Não existem pictogramas.",
        noExistingStops: "Não existem paragens disponíveis",
        noFooterImages: "Não existem imagens de rodapé disponíveis",
        noHeaderImages: "Não existem imagens de cabeçalho disponíveis",
        noMapPointsAvailable: "Não existem pontos notáveis disponíveis",
        orientation: "Orientação",
        origin: "Origem",
        pageDimensions: "Dimensões da página (em mm)",
        pageFooterHeight: "Altura Rodapé",
        pageHeaderHeight: "Altura Cabeçalho",
        pageHeight: "Altura",
        pageMarginBottom: "Baixo",
        pageMarginLeft: "Esquerda",
        pageMarginRight: "Direita",
        pageMargins: "Margens",
        pageMarginTop: "Cima",
        pageRouteHeaderHeight: "Altura do Cabeçalho das Rotas",
        pageSizes: "Tamanho da Página",
        pageWidth: "Largura",
        part: "Parte",
        printInterfaces: "Mostrar interfaces",
        printInterfacesLabel: "Mostrar legenda das interfaces",
        printProviderLogo: "Mostrar logotipo do operador",
        printTitle: "Mostrar título",
        removeImage: "Remover imagem",
        removedImage: "Imagem removida com sucesso",
        required: "Obrigatório",
        return: "Volta",
        save: "Guardar alterações",
        selectAll: "Selecionar todos",
        selectAllRoutesForAllStops: "Selecionar tudo",
        selectAllVisibleStops: "Selecionar paragens visíveis",
        selectedStops: "Paragens selecionadas",
        selectMapPoints: "Selecionar pontos notáveis",
        selectRoutes: "Selecionar rotas",
        selectStops: "Selecionar paragens",
        settings: "Definições",
        settingsUpdated: "Definições alteradas com sucesso",
        shortName: "Abreviatura",
        showSettings: "Mostrar definições",
        showSummary: "Mostrar Resumo",
        stopLabel: "Legenda da Paragem",
        stopLabelColor: "Cor de fundo",
        stopLabelFont: "Tipo de letra",
        stopLabelTextColor: "Cor do texto",
        stopsWithNoRoutes: "Não existem percursos associados com as seguintes paragens:",
        success: "Sucesso",
        summary: "Resumo",
        terminalStopsWithoutMapPoints: "Paragens término não associadas com pontos notáveis para os seguintes percursos:",
        type: "Tipo",
        upload: "Carregar",
        uploadButton: "Carregar",
        uploadNew: "Carregar nova imagem",
        warning: "Aviso",
        yes: "Sim"
    }
});
